export function shouldShowNavigationItems(session){var _session$user;/* 
    Display navigation items if the user 
    1. is signed in
    2. has submitted accreditation verification
   */return!!(session!==null&&session!==void 0&&(_session$user=session.user)!==null&&_session$user!==void 0&&_session$user.accreditationStatus);}